var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-block',{attrs:{"mod-class":"","content-class":"order-was-create","title-page":"Спасибо"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_vm._v(" Задача успешно создана ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }